<router-outlet (activate)="activated = true" (deactivate)="activated = false"></router-outlet>

<ng-container *ngIf="!activated">
  <div class="h-full w-full flex flex-column align-items-center justify-content-center">
    <img class="rotate-center h-10rem w-10rem" src="assets/svg/flower.svg">
    <div>Solo un secondo...</div>
  </div>
</ng-container>
